<div class="section-upload">
  <!-- <label><strong>{{ label }}</strong></label> -->
  
  <div class="position-relative h-124px mb-3">
   <ng-container>
     <input type="file" accept="image/*" multiple (change)="onFileSelected($event)" class="ng-star-inserted d-block w-100 h-124px file position-absolute">
    <img src="assets/images/apartmentImages/_File upload base.svg" class="position-absolute" width="100%">
   </ng-container>
  </div>

  <div class="row mt-3">
    <div class="col-md-2" *ngFor="let image of images">
      <button class="delete-btn" (click)="removeImage(image)">
        <img src="assets/images/delete.svg" width="24">
      </button>
      <img [src]="image" class="uploaded-img" alt="Section image">
    </div>
  </div>
</div>
